<template>
  <v-navigation-drawer v-if="$route.name !== 'Login'" app color="#111111" fixed permanent>
    <v-list-item>
      <v-list-item-avatar>
        <v-img :src="this.$store.state.currentUser.imageUrl" contain></v-img>
      </v-list-item-avatar>
      <v-list-item-title class="d-flex justify-start"><p class="mt-4 ml-1" style="color: #FFFFFF">
        {{ this.$store.state.currentUser.firstName }}</p></v-list-item-title>
    </v-list-item>

    <v-divider dark/>

    <v-list dense rounded>
      <v-list-item v-for="item in items" :key="item.name" link @click="goToOption(item)">
        <v-list-item-icon>
          <v-icon :color="(item.name === itemSelected)? '#00f553' : '#FFFFFF'" small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="ml-n5">
          <v-list-item-title class="d-flex justify-start">
            <p :style="(item.name === itemSelected)? 'color: #00f553' : 'color: #FFFFFF'" class="mt-1">
            {{ item.name }}
            </p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list-item @click="logoutUser">
        <v-list-item-icon>
          <v-icon color="#FFFFFF" small>fa-power-off</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="ml-n5">
          <v-list-item-title class="d-flex justify-start"><p class="mt-1" style="color: #FFFFFF">Logout</p>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import {mapMutations} from 'vuex';

export default {
  name: "Navbar",
  data() {
    return {
      itemSelected: 'Dashboard',
      items: [
        {name: 'Dashboard', icon: 'fa-tachometer-alt', path: '/dashboard'},
        {name: 'Users', icon: 'fa-users', path: '/users'},
        {name: 'Trades', icon: 'fa-stream', path: '/trades'},
        {name: 'Payments', icon: 'fa-money-check-alt', path: '/payments'},
        {name: 'Coupons', icon: 'fa-tags', path: '/coupons'},
        {name: 'Meta-Credentials', icon: 'fa-key', path: '/meta-credentials'},
        {name: 'Communities', icon: 'fa-users', path: '/clubs'},
        // {name: 'Software Backlog', icon: 'fa-laptop', path: '/backlog'},
        {name: 'Help Desk', icon: 'fa-life-ring', path: '/help-desk'},
      ],
    };
  },
  methods: {
    goToOption(item) {
      this.itemSelected = item.name;
      this.$router.push(item.path);
    },
    ...mapMutations(['logout']),
    logoutUser() {
      this.logout();
      this.$router.push('/');
    },
  },
}
</script>

<style scoped>

</style>
